import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import {
  BarChart3,
  Package,
  Users,
  Building2,
  ArrowRight,
  AlertTriangle,
  FileText,
  Search,
  ShoppingCart,
  TrendingUp,
  Activity,
  Zap,
  Settings,
  Database,
  DollarSign,
  Percent,
  Calendar,
  Clock,
  MessageSquare,
  Shield,
  FileSpreadsheet,
  Briefcase,
  Truck,
  Inbox,
  Cpu,
  Globe,
  Layers,
  List,
  ClipboardList,
  FileCheck,
  HelpCircle,
  Bell,
  Bookmark,
  Tag,
  CheckCircle2,
  Info,
  TrendingDown,
  Heart,
  Star,
  Play,
  Terminal,
  Calculator,
  CreditCard,
  Wallet,
  Gift,
  Award,
  Key,
  Lock,
  Unlock,
  Eye,
  EyeOff,
  Filter,
  Download,
  Upload,
  Share2,
  Link,
  Mail,
  Phone,
  UserCheck,
  UserX,
  MapPin,
  Map,
  Compass,
  Printer,
  Trash2,
  Edit3,
  Plus,
  Minus,
  Folder,
  FolderOpen,
  HardDrive,
  Cloud,
  CloudDownload,
  CloudUpload,
  Book,
  BookOpen,
  Tags,
  Wrench,
  Sliders,
  History,
  RefreshCw
} from 'lucide-react';

const ICON_MAP = {
  'AlertTriangle': AlertTriangle,
  'Package': Package,
  'Users': Users,
  'Building2': Building2,
  'BarChart3': BarChart3,
  'FileText': FileText,
  'Search': Search,
  'ShoppingCart': ShoppingCart,
  'TrendingUp': TrendingUp,
  'Activity': Activity,
  'Zap': Zap,
  'Settings': Settings,
  'Database': Database,
  'DollarSign': DollarSign,
  'Percent': Percent,
  'Calendar': Calendar,
  'Clock': Clock,
  'MessageSquare': MessageSquare,
  'Shield': Shield,
  'FileSpreadsheet': FileSpreadsheet,
  'Briefcase': Briefcase,
  'Truck': Truck,
  'Inbox': Inbox,
  'Cpu': Cpu,
  'Globe': Globe,
  'Layers': Layers,
  'List': List,
  'ClipboardList': ClipboardList,
  'FileCheck': FileCheck,
  'HelpCircle': HelpCircle,
  'Bell': Bell,
  'Bookmark': Bookmark,
  'Tag': Tag,
  'CheckCircle2': CheckCircle2,
  'Info': Info,
  'TrendingDown': TrendingDown,
  'Heart': Heart,
  'Star': Star,
  'Play': Play,
  'Terminal': Terminal,
  'Calculator': Calculator,
  'CreditCard': CreditCard,
  'Wallet': Wallet,
  'Gift': Gift,
  'Award': Award,
  'Key': Key,
  'Lock': Lock,
  'Unlock': Unlock,
  'Eye': Eye,
  'EyeOff': EyeOff,
  'Filter': Filter,
  'Download': Download,
  'Upload': Upload,
  'Share2': Share2,
  'Link': Link,
  'Mail': Mail,
  'Phone': Phone,
  'UserCheck': UserCheck,
  'UserX': UserX,
  'MapPin': MapPin,
  'Map': Map,
  'Compass': Compass,
  'Printer': Printer,
  'Trash2': Trash2,
  'Edit3': Edit3,
  'Plus': Plus,
  'Minus': Minus,
  'Folder': Folder,
  'FolderOpen': FolderOpen,
  'HardDrive': HardDrive,
  'Cloud': Cloud,
  'CloudDownload': CloudDownload,
  'CloudUpload': CloudUpload,
  'Book': Book,
  'BookOpen': BookOpen,
  'Tags': Tags,
  'Wrench': Wrench,
  'Sliders': Sliders,
  'History': History,
  'RefreshCw': RefreshCw
};

const COLOR_MAP = {
  'red':    'bg-red-500',
  'cyan':   'bg-[#00B7D4]',
  'blue':   'bg-blue-500',
  'green':  'bg-green-500',
  'yellow': 'bg-yellow-500',
  'orange': 'bg-orange-500',
  'purple': 'bg-purple-500',
  'gray':   'bg-gray-500'
};

const AREA_LABEL = {
  compras: 'Compras',
  ventas:  'Ventas',
  stock:   'Stock',
  general: 'General',
};

const WelcomeMessage = ({ userName, onQuickAction, quickActions = [], selectedArea }) => {
  // Filtrar por área seleccionada
  const filtered = selectedArea
    ? quickActions.filter(a => (a.area || 'general') === selectedArea)
    : quickActions;

  const areaLabel = selectedArea
    ? (AREA_LABEL[selectedArea] || selectedArea.charAt(0).toUpperCase() + selectedArea.slice(1))
    : '';

  return (
    <div className="py-8" data-testid="welcome-message">
      <div className="text-center mb-10">
        <div className="flex justify-center mb-4">
          <img src="/logo-cdsur.png" alt="CDSur" className="h-16 w-auto opacity-90" />
        </div>
        <h2 className="text-2xl font-bold mb-2">
          Hola{userName ? `, ${userName}` : ''}
        </h2>
        <p className="text-muted-foreground max-w-lg mx-auto">
          {areaLabel
            ? `Módulo ${areaLabel} — seleccioná una acción rápida o escribí tu consulta.`
            : 'Seleccioná un módulo en el menú lateral para comenzar.'}
        </p>
      </div>

      {filtered.length === 0 ? (
        <p className="text-center text-sm text-muted-foreground py-4">
          No hay acciones rápidas disponibles en este módulo.
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
          {filtered.map((action) => {
            const Icon = ICON_MAP[action.icon] || Package;
            return (
              <Card
                key={action.id}
                className="cursor-pointer hover:shadow-md transition-all border-border/50 hover:border-[#00B7D4]/30 group"
                onClick={() => onQuickAction(action.prompt, action.id)}
                data-testid={`quick-action-${action.id}`}
              >
                <CardContent className="p-4 flex items-start gap-4">
                  <div className={`${COLOR_MAP[action.color] || 'bg-gray-500'} p-2 rounded-lg shrink-0`}>
                    <Icon className="h-5 w-5 text-white" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-medium mb-1 group-hover:text-[#00B7D4] transition-colors">
                      {action.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      {action.description}
                    </p>
                  </div>
                  <ArrowRight className="h-4 w-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity mt-1 shrink-0" />
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WelcomeMessage;
